import React from 'react';

const StudentPortalButton: React.FC = () => {
  const handleClick = () => {
    window.open('/student/portal', '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow-lg p-3 hover:shadow-xl transition-all duration-300 flex flex-col items-center gap-2 z-50"
      style={{
        width: '80px',
        height: '120px',
        borderRadius: '8px',
      }}
      title="打开学生看课平台"
    >
      <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
        <span className="text-2xl">🧒</span>
      </div>
      <div className="flex flex-col items-center">
        <span className="text-sm font-medium">看课</span>
        <span className="text-lg">➡️</span>
      </div>
    </button>
  );
};

export default StudentPortalButton;